/**
 * Created by andromeda on 4/18/2017.
 */


import tdLog from './tdLog.js'
import {store} from './store.js'

//import router based on the environment (dev/prod)
let router;
if (process.env.NODE_ENV === 'development') {
    router = require('./router/indexDev.js').default;
} else {
    router = require('./router/index.js').default;
}

import tdDeploy from './tdDeploy.js'
import tdLocalStorage from "./tdLocalStorage";


export default class tdApi {


    /**
     * The endPoint that we use for this instance
     * @type {null}
     * @private
     */
    _apiEndPoint = null;
    _apiUrl = '';
    _uniqueID = null;




    constructor (apiEndPoint, apiUrl) {
        if (apiEndPoint === undefined) {
            tdLog.kill('apiEndPoint is undefined');
        }

        this._apiEndPoint = apiEndPoint;


        this._apiUrl = tdDeploy.apiUrl;
        if (apiUrl !== undefined && apiUrl === 'apiThumb') {
            this._apiUrl = tdDeploy.apiThumbUrl;
        } else if (apiUrl === 'api_user_photo') {
            this._apiUrl = tdDeploy.apiUploadPhotoUrl;
        }
    }





    /**
     * Runs an api call
     * @param options
     * @param uniqueID number
     *
     * @param options.post The post data
     * @param options.accessToken - access token - if non provided we will look in the datastore. This is usually provided just for unit testing
     * ---------------- callbacks ------------------
     * @param options.fatal_error - api replied with a fatal error
     * @param options.http_error - HTTP error OR Empty http reply!
     * @param options.done - done callback
     * @param options.error - api error callback
     */
    run (options, uniqueID) {
        if (uniqueID !== undefined) {
            this._uniqueID = uniqueID;
        }

        // add a console separator after some time
        setTimeout(function(){
                console.log('-----------------------');
            }.bind(this), 1000
        );


        if (this._apiEndPoint === null) {
            tdLog.kill('Missing api endpoint');
        }


        if (options.post === undefined) {
            options.post = {};
            //tdLog.kill('Missing post data');
        }



        // default api timeout
        // @since 6.5.2020 - it was increased to 2 minutes
        if (options.timeout === undefined) {
            options.timeout = 300000;
        }

        if (options.done === undefined) {
            tdLog.kill('Missing done');
        }


        /**
         * options.accessToken is used on the login page.
         */
        if (options.accessToken !== undefined) {
            options.post.api_auth = options.accessToken;
        } else if (store.getters.isLoggedIn === true) {
            //add the auth object for all other requests
            options.post.api_auth = {
                'session_token':  store.state.user.session_token,
                'session_company_id':  store.state.user.session_company_id,
            };
        }


        // set the api_language, from state.companyLanguage
        options.post.api_language = store.getters.getUserLanguage;


        // define a default fatal_error callback if we didn't got one already. We override this method in Gunit
        if (options.fatal_error === undefined) {
            options.fatal_error = function (fatalErrorObj) {
                console.log('%cFATAL ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', fatalErrorObj);
                window.EventBus.$emit('banner_onErrorPermanent', 'Error', fatalErrorObj, null, this._apiEndPoint);
            }.bind(this);
        }


        // define a default http error callback - this callback is called on connection issues (404 500 empty response etc...)
        if (options.http_error === undefined) {
            options.http_error = function (message) {
                console.log('%cAJAX HTTP ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }


        // define an default error callback
        if (options.error === undefined) {
            options.error = function (message) {
                console.log('%cAPI ERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', 'Eroare', message, this._apiEndPoint);
                //window.EventBus.$emit('banner_onErrorPermanent', 'Eroare2', message, this._apiEndPoint);
            }.bind(this);
        }



        jQuery.ajax({
            timeout: options.timeout,
            type: 'POST',

            // the tmp_ query parameters and the uuid are for cache busting and for easier debug-ing. We ONLY USE post variables.
            url: this._apiUrl + this._apiEndPoint + '?uuid=' + this._getUniqueID(),

            // add the nonce used for cookie authentication
            beforeSend: function ( xhr ) {
                //xhr.setRequestHeader( 'X-WP-Nonce', window.tdcAdminSettings.wpRestNonce);
            },
            cache: false,
            data: options.post,
            dataType: 'json',

            // callbacks for status codes errors, note that the error callback also fires when a strange status code is received
            statusCode: {
                404 : function(response) {
                    options.http_error(this._apiEndPoint + ': ERROR: 404 not found');
                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                }.bind(this),
                500 : function(response) {
                    options.http_error(this._apiEndPoint + ': ERROR: 500 server error - ' + response.responseText);
                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                }.bind(this)
            },


            success: function(apiReply, textStatus, XMLHttpRequest) {
                //console.log(apiReply);
                let apiResponseLength = 0;
                // log the request
                if (apiReply === null) {
                    apiResponseLength = 0;
                } else {
                    apiResponseLength = JSON.stringify(apiReply).length;
                }


                // show a warning when a reply has more than 40.000 characters
                if (apiResponseLength > 40000) {
                    console.group('API: ' + this._apiEndPoint + ' - length: %c' + apiResponseLength , 'background: #ffaa00; color: #ffffff; padding:3px 6px');
                } else {
                    console.group('API: ' + this._apiEndPoint);
                }

                //check iflow version (reload if local version !== server version)
                let td_iflow_version = tdLocalStorage.get('td_iflow_version');
                if (apiReply && apiReply.td_iflow_version && td_iflow_version !== null && td_iflow_version !== '' && apiReply.td_iflow_version !== tdLocalStorage.get('td_iflow_version')) {
                    // console.log("Server version: " + apiReply.td_iflow_version);
                    // console.log("Local version: " + tdLocalStorage.get('td_iflow_version'));

                    //keep it in localStorage because vue.$store resets on page reload
                    tdLocalStorage.set('td_iflow_version', apiReply.td_iflow_version);
                    window.location.reload(true);
                }


                    console.log('Post: ', options.post);
                    console.log('Reply: ', apiReply);


                    if (apiReply === null) {
                        window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                        options.http_error('ERROR: Empty response received from server');
                        console.groupEnd();
                        return;
                    }

                    if (apiReply.api_reply.fatal_error !== undefined) {

                        if (apiReply.api_reply.fatal_error.more !== undefined && apiReply.api_reply.fatal_error.more.redirect_login === true) {
                            console.groupEnd();
                            window.EventBus.$emit('appLoader_hide');

                            //flag used to allow only one redirect to logOut page
                            if (window.tdRedirectedToLogOut !== true) {
                                window.tdRedirectedToLogOut = true;
                                router.push('/logOut/?error_code=logout_1');
                            }

                            return;
                        }

                        window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                        options.fatal_error(apiReply.api_reply);
                        console.groupEnd();
                        return;
                    }





                // encountered a soft error
                if (apiReply.api_reply.error !== undefined) {
                    options.error(apiReply.api_reply.error); // this will not be called on fatal_error
                } else {
                    options.done(apiReply.api_reply, this._uniqueID);
                }


                console.groupEnd();

                //personal data leakage
                if (apiReply.personal_data_leakages !== undefined && apiReply.personal_data_leakages.length > 0) {
                    console.log('%c Personal data leak detected: ', 'background: #222; color: #ffA500; padding: 2px 4px; font-size: 13px; font-weight: 600;', apiReply.personal_data_leakages);
                }

            }.bind(this),

            // this callback is called when any error is encountered. (including status codes like 404, 500 etc)
            //  - this is not the same with the case when the API replys with errors, this is a FATAL error and
            //  - is handled here with options.http_error
            //  - when a 404/500 error appears, first this hook is called, after that the ones from statusCode above ^
            error: function(MLHttpRequest, textStatus, errorThrown){
                if (MLHttpRequest.responseText !== undefined) {
                    if (MLHttpRequest.responseText === '') {
                        options.http_error(this._apiEndPoint + ': Empty response from API');
                    } else {
                        options.http_error(this._apiEndPoint + ': ' + MLHttpRequest.responseText);
                    }

                } else {

                    if (textStatus !== undefined) {
                        options.http_error(this._apiEndPoint + ': tdApi.run Timeout or Internet connexion problem - textStatus: ' + textStatus);
                    } else {
                        options.http_error(this._apiEndPoint + ': Internet connexion problem. Remote API could not be reached');
                    }


                }

                window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
            }.bind(this)
        });

    }


    /**
     * Uses FormData api to send blobs. It will be used to send PDF invoices / files generated in browser to the server -> and then to email
     * - it has some strange stuff to look like the original tdApi.run() method
     * @param options
     * @param uniqueID
     */
    sendBlob(options, uniqueID) {
        if (uniqueID !== undefined) {
            this._uniqueID = uniqueID;
        }

        // add a console separator after some time
        setTimeout(function(){
                console.log('-----------------------');
            }.bind(this), 1000
        );


        if (this._apiEndPoint === null) {
            tdLog.kill('Missing api endpoint');
        }


        if (options.post === undefined) {
            options.post = {};
            //tdLog.kill('Missing post data');
        }



        // default api timeout
        // @since 6.5.2020 - it was increased to 2 minutes
        if (options.timeout === undefined) {
            options.timeout = 300000;
        }

        if (options.done === undefined) {
            tdLog.kill('Missing done');
        }


        /**
         * options.accessToken is used on the login page.
         */
        if (options.accessToken !== undefined) {
            options.post.api_auth = options.accessToken;
        } else if (store.getters.isLoggedIn === true) {
            //add the auth object for all other requests
            options.post.api_auth = {
                'session_token':  store.state.user.session_token,
                'session_company_id':  store.state.user.session_company_id,
            };
        }


        // set the api_language, from state.companyLanguage
        options.post.api_language = store.getters.getUserLanguage;


        // define a default fatal_error callback if we didn't got one already. We override this method in Gunit
        if (options.fatal_error === undefined) {
            options.fatal_error = function (fatalErrorObj) {
                console.log('%cFATAL ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', fatalErrorObj);
                window.EventBus.$emit('banner_onErrorPermanent', 'API replied with fatal error. Try to refresh the page. The error that we got:', fatalErrorObj, null, this._apiEndPoint);
            }.bind(this);
        }


        // define a default http error callback - this callback is called on connection issues (404 500 empty response etc...)
        if (options.http_error === undefined) {
            options.http_error = function (message) {
                console.log('%cAJAX HTTP ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }


        // define an default error callback
        if (options.error === undefined) {
            options.error = function (message) {
                console.log('%cAPI ERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', 'Eroare', message, this._apiEndPoint);
                //window.EventBus.$emit('banner_onErrorPermanent', 'Eroare2', message, this._apiEndPoint);
            }.bind(this);
        }


        let formData = new FormData();



        for (const postKey in options.post) {
            // if one of the values is a object or array we have to rebuild the formData
            if (Array.isArray(options.post[postKey]) || typeof options.post[postKey] === 'object') {
                //console.log('the obj', options.post[postKey]);
                for (const postValueObjKey in options.post[postKey]) {
                    formData.append(postKey + '[' + postValueObjKey + ']', options.post[postKey][postValueObjKey]);
                }
            } else {
                formData.append(postKey, options.post[postKey]);
            }
        }

        options.files.forEach(
            function (currentValue, index, arr) {
                formData.append('td_upload_files[]', currentValue.blob, currentValue.blobFilename);
            }
        );

        jQuery.ajax({
            timeout: options.timeout,
            type: 'POST',

            // the tmp_ query parameters and the uuid are for cache busting and for easier debug-ing. We ONLY USE post variables.
            url: this._apiUrl + this._apiEndPoint + '?uuid=' + this._getUniqueID(),

            // add the nonce used for cookie authentication
            beforeSend: function ( xhr ) {
                //xhr.setRequestHeader( 'X-WP-Nonce', window.tdcAdminSettings.wpRestNonce);
            },
            cache: false,
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,


            // callbacks for status codes errors, note that the error callback also fires when a strange status code is received
            statusCode: {
                404 : function(response) {
                    options.http_error(this._apiEndPoint + ': ERROR: 404 not found');
                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                }.bind(this),
                500 : function(response) {
                    options.http_error(this._apiEndPoint + ': ERROR: 500 server error - ' + response.responseText);
                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                }.bind(this)
            },


            success: function(apiReply, textStatus, XMLHttpRequest) {
                //console.log(apiReply);
                let apiResponseLength = 0;
                // log the request
                if (apiReply === null) {
                    apiResponseLength = 0;
                } else {
                    apiResponseLength = JSON.stringify(apiReply).length;
                }


                // show a warning when a reply has more than 40.000 characters
                if (apiResponseLength > 40000) {
                    console.group('API: ' + this._apiEndPoint + ' - length: %c' + apiResponseLength , 'background: #ffaa00; color: #ffffff; padding:3px 6px');
                } else {
                    console.group('API: ' + this._apiEndPoint);
                }


                // build the post buffer for debug
                let postBuffer = [];
                for(var pair of formData.entries()) {
                    let curObject = {};
                    postBuffer[pair[0]] = pair[1];
                }

                console.log('Post: ', postBuffer);
                console.log('Reply: ', apiReply);


                if (apiReply === null) {
                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                    options.http_error('ERROR: Empty response received from server');
                    console.groupEnd();
                    return;
                }

                if (apiReply.api_reply.fatal_error !== undefined) {

                    if (apiReply.api_reply.fatal_error.more !== undefined && apiReply.api_reply.fatal_error.more.redirect_login === true) {
                        console.groupEnd();
                        window.EventBus.$emit('appLoader_hide');

                        //flag used to allow only one redirect to logOut page
                        if (window.tdRedirectedToLogOut !== true) {
                            window.tdRedirectedToLogOut = true;
                            router.push('/logOut/?error_code=logout_1');
                        }

                        return;
                    }

                    window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
                    options.fatal_error(apiReply.api_reply);
                    console.groupEnd();
                    return;
                }





                // encountered a soft error
                if (apiReply.api_reply.error !== undefined) {
                    options.error(apiReply.api_reply.error); // this will not be called on fatal_error
                } else {
                    options.done(apiReply.api_reply, this._uniqueID);
                }


                console.groupEnd();
            }.bind(this),

            // this callback is called when any error is encountered. (including status codes like 404, 500 etc)
            //  - this is not the same with the case when the API replys with errors, this is a FATAL error and
            //  - is handled here with options.http_error
            //  - when a 404/500 error appears, first this hook is called, after that the ones from statusCode above ^
            error: function(MLHttpRequest, textStatus, errorThrown){
                if (MLHttpRequest.responseText !== undefined) {
                    if (MLHttpRequest.responseText === '') {
                        options.http_error(this._apiEndPoint + ': Empty response from API');
                    } else {
                        options.http_error(this._apiEndPoint + ': ' + MLHttpRequest.responseText);
                    }

                } else {

                    if (textStatus !== undefined) {
                        options.http_error(this._apiEndPoint + ': tdApi.run Timeout or Internet connexion problem - textStatus: ' + textStatus);
                    } else {
                        options.http_error(this._apiEndPoint + ': Internet connexion problem. Remote API could not be reached');
                    }


                }

                window.EventBus.$emit('appLoader_hide'); // close any running loaders on error
            }.bind(this)
        });


    }

    runx(options) {
        // add a console separator after some time
        setTimeout(function() {
            console.log('-----------------------');
        }.bind(this), 1000);

        if (this._apiEndPoint === null) {
            tdLog.kill('Missing api endpoint');
        }

        if (options.post === undefined) {
            options.post = {};
        }

        if (options.done === undefined) {
            tdLog.kill('Missing done');
        }

        // options.accessToken is used on the login page.
        if (options.accessToken !== undefined) {
            options.post.api_auth = options.accessToken;
        } else if (store.getters.isLoggedIn === true) {
            // add the auth object for all other requests
            options.post.api_auth = {
                'session_token':  store.state.user.session_token,
                'session_company_id':  store.state.user.session_company_id,
            };
        }

        // set the api_language, from state.companyLanguage
        options.post.api_language = store.getters.getUserLanguage;

        // define a default fatal_error callback if we didn't get one already
        if (options.fatal_error === undefined) {
            options.fatal_error = function(message) {
                console.log('%cFATAL ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }

        // define a default http error callback - this callback is called on connection issues (404 500 empty response etc...)
        if (options.http_error === undefined) {
            options.http_error = function(message) {
                console.log('%cAJAX HTTP ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }

        // define a default error callback
        if (options.error === undefined) {
            options.error = function(message) {
                console.log('%cAPI ERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', message);
            };
        }

        let xhr = new XMLHttpRequest();
        xhr.open('POST', this._apiUrl + this._apiEndPoint + '?uuid=' + this._getUniqueID(), true);
        xhr.responseType = 'arraybuffer';
        let vm = this;
        xhr.onload = function() {
            console.group('API runX(): ' + vm._apiEndPoint);

            if (this.status === 200) {
                // file name
                let filename = "",
                    disposition = xhr.getResponseHeader('Content-Disposition');

                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                // blob
                let type = xhr.getResponseHeader('Content-Type'),
                    blob = typeof File === 'function'
                        ? new File([this.response], filename, { type: type })
                        : new Blob([this.response], { type: type });

                // Convert blob to base64
                const reader = new FileReader();
                reader.onloadend = function() {
                    const base64data = reader.result.split(',')[1]; // Extract Base64 part

                    // Send base64 data and filename to Swift app
                    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fileHandler) {
                        // Create an object containing both filename and base64 data
                        const fileData = {
                            filename: filename,
                            content: base64data
                        };

                        // Send the object as a JSON string to the iOS Swift app
                        window.webkit.messageHandlers.fileHandler.postMessage(JSON.stringify(fileData));
                    }
                };
                reader.readAsDataURL(blob);

                if (!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fileHandler)) {
                    // Original download logic
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        let URL = window.URL || window.webkitURL,
                            downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            let a = document.createElement("a");
                            if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                a.style.display = "none";
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function() { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                    }
                }

                console.log('Post: ', options.post);
                console.log('Reply: ', "200 ok, filename: " + filename + " + a blob, see on network tab");
                options.done({
                    'api_reply': {
                        'ok': 'ok'
                    }
                });
            } else {
                options.error({
                    'errorMessage': 'Failed to download the file, status: ' + this.status
                });
            }

            console.groupEnd();
        };

        // form data
        let formData = this._objectToFormData(options.post, new FormData());

        // send xhr request
        xhr.send(formData);
    }


    runx_2fa(options) {
        // add a console separator after some time
        setTimeout(function(){
                console.log('-----------------------');
            }.bind(this), 1000
        );

        if (this._apiEndPoint === null) {
            tdLog.kill('Missing api endpoint');
        }

        if (options.post === undefined) {
            options.post = {};
        }

        if (options.done === undefined) {
            tdLog.kill('Missing done');
        }

        // options.accessToken is used on the login page.
        if (options.accessToken !== undefined) {
            options.post.api_auth = options.accessToken;
        } else if (store.getters.isLoggedIn === true) {
            // add the auth object for all other requests
            options.post.api_auth = {
                'session_token':  store.state.user.session_token,
                'session_company_id':  store.state.user.session_company_id,
            };
        }

        // set the api_language, from state.companyLanguage
        options.post.api_language = store.getters.getUserLanguage;

        // define a default fatal_error callback if we didn't get one already
        if (options.fatal_error === undefined) {
            options.fatal_error = function (message) {
                console.log('%cFATAL ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }

        // define a default http error callback - this callback is called on connection issues (404 500 empty response etc...)
        if (options.http_error === undefined) {
            options.http_error = function (message) {
                console.log('%cAJAX HTTP ERROR', 'background: #f45642; color: #ffffff; padding:3px 6px', message);
                window.EventBus.$emit('banner_onErrorPermanent', message, null, this._apiEndPoint);
            }.bind(this);
        }

        // define a default error callback
        if (options.error === undefined) {
            options.error = function (message) {
                console.log('%cAPI ERROR', 'background: #ffaa00; color: #ffffff; padding:3px 6px', message);
            };
        }

        let xhr = new XMLHttpRequest();
        xhr.open('POST', this._apiUrl + this._apiEndPoint + '?uuid=' + this._getUniqueID(), true);
        xhr.responseType = 'arraybuffer';
        let vm = this;
        xhr.onload = function () {
            console.group('API runX(): ' + vm._apiEndPoint);

            if (this.status === 200) {
                // file name
                let filename = "",
                    disposition = xhr.getResponseHeader('Content-Disposition');

                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                // blob
                let type = xhr.getResponseHeader('Content-Type'),
                    blob = typeof File === 'function'
                        ? new File([this.response], filename, { type: type })
                        : new Blob([this.response], { type: type });

                // Convert blob to base64
                const reader = new FileReader();
                reader.onloadend = function() {
                    const base64data = reader.result.split(',')[1]; // Extract Base64 part

                    // Send base64 data and filename to Swift app
                    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fileHandler) {
                        // Create an object containing both filename and base64 data
                        const fileData = {
                            filename: filename,
                            content: base64data
                        };

                        // Send the object as a JSON string to the iOS Swift app
                        window.webkit.messageHandlers.fileHandler.postMessage(JSON.stringify(fileData));
                    }
                };
                reader.readAsDataURL(blob);

                if (!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.fileHandler)) {
                    // Original download logic
                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        let URL = window.URL || window.webkitURL,
                            downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            let a = document.createElement("a");
                            if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                a.style.display = "none";
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                    }
                }

                console.log('Post: ', options.post);
                console.log('Reply: ', "200 ok, filename: " + filename + " + a blob, see on network tab");
                options.done(this.response);
            } else {
                let blob = new Blob([this.response], {
                    type: "application/json",
                });

                const reader = new FileReader();
                reader.addEventListener('loadend', (e) => {
                    let text_reply = e.srcElement.result;
                    let reply = JSON.parse(text_reply);
                    options.error(reply.api_reply);
                });

                reader.readAsText(blob);
            }

            console.groupEnd();
        };

        // form data
        let formData = this._objectToFormData(options.post, new FormData());

        // send xhr request
        xhr.send(formData);
    }



    _objectToFormData(obj, form, namespace) {
        //object to formData
        let fd = form || new FormData(),
            formKey;

        for(let property in obj) {
            if(obj.hasOwnProperty(property)) {

                if(namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }

                // if the property is an object, but not a File,
                // use recursivity.
                if(typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

                    this._objectToFormData(obj[property], fd, formKey);

                } else {

                    // if it's a string or a File object
                    fd.append(formKey, obj[property]);
                }

            }
        }

        return fd;
    }



    _getUniqueID() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }






}



// WEBPACK FOOTER //
// ./src/tdApi.js